import { recordAccess } from '../api/accessRecord';

let lastPath = '';
let previousPath = '';

function cleanUrl(value) {
  if (!value) return '';
  try {
    const url = new URL(value, window.location.origin);
    return url.origin + url.pathname + url.search;
  } catch (error) {
    return String(value || '').split('#')[0];
  }
}

export function trackCurrentPage() {
  const accessUrl = cleanUrl(window.location.href);
  if (accessUrl === lastPath) return;
  const referrerUrl = previousPath || cleanUrl(document.referrer);
  previousPath = accessUrl;
  lastPath = accessUrl;
  recordAccess(accessUrl, referrerUrl).catch(() => {});
}
